module.exports = __webpack_public_path__ + "static/media/soul_machines_ex.4c1f2260.png";